<template>
    <div v-if="status" :id="`loaderWrap${componentId}`" class="loadingWrap opacityOverlay">
        <div :id="`loader${componentId}`" class="loading">
            <div class="img-wrap">
                <div class="loader-img-overlay">
                    <div></div>
                    <div></div>
                </div>
            </div>
            <div class="text-wrap">{{ text }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Loader',
    props: {
        status: Boolean,
        text: {
            type: String,
            default: 'Loading',
            require: false
        }
    },
    computed: {
        componentId() {
            return `loader${Math.floor((Math.random() * 1000) + 1)}`;
        }
    }
};
</script>

<style scoped lang="scss">
    @import "~styles/styleGuide";

    //overlay loader
    $overlayLoaderBG: $white;//$generalBackground;
    $overlayLoaderTextColor: $dark-300;
    $overlayLoaderImgColor: $light-800;
    $overlayLoaderImgSize: 50px;
    $overlayLoaderMediumImgSize: 30px;
    $overlayLoaderTextMargin: 10px;
    $overlayLoaderTextHeight: 20px;

    //inline (actions, in buttons....)
    $inlineLoaderImgSize: 13px;
    $inlineLoaderTextColor: $dark-300;
    $inlineLoaderImgColor: $light-800;

    //inline loader Wrapper
    .loader-inline{
        display: inline-flex;
        margin-left: 5px;
        vertical-align: middle;
        height: $inlineLoaderImgSize;
        .loader-txt {
            @include font(5);
            padding-left: 4px;
            padding-top: 1px;
            color: $inlineLoaderTextColor;
        }
    }

    //Overlay Loader Wrapper
    .loadingWrap{
        position: absolute;
        top:0;
        left:0;
        right:0;
        bottom:0;
        overflow: hidden;
        .loading{
            text-align: center;
            position: absolute;
            right:0;
            left:0;
            top: calc(50% - #{$overlayLoaderImgSize}/2 - #{$overlayLoaderTextHeight}/2 - #{$overlayLoaderTextMargin}/2);
            .text-wrap{
                @include font(2);
                line-height: $overlayLoaderTextHeight;
                color: $overlayLoaderTextColor;
                margin-top: $overlayLoaderTextMargin;
            }
            .img-wrap{
                width: $overlayLoaderImgSize;
                height: $overlayLoaderImgSize;
                margin: 0 auto;
            }
        }
        &.opacityOverlay{
            z-index: 10;
            //opacity: .81;
            background:$overlayLoaderBG;
        }
    }

    //overlay loader style
    @import "ball-scale-ripple-multiple";
</style>
